import React from "react";

import LoadingIndicator from "../../Chat/components/Loading";

const Loading = ({ count }) => {
  return (
    <div className="suggestions">
      {Array.from(Array(count)).map((_, index) => (
        <div key={index} className="suggestion loading">
          <LoadingIndicator />
        </div>
      ))}
    </div>
  )
}

export default Loading;
